import { core } from '@tock/coretypes';
import { getOtherTicketTypeQuestionOption } from '@tock/shared/utils/questionUtils';

/**
 * Appends an "other" option to the end of the user provided question response options when
 * configuration allows it.
 */
export const getOptionsFromQuestion = (
  question: core.TicketTypeQuestion
): core.ITicketTypeQuestionOption[] => {
  if (question.allowOther) {
    return [...question.options, getOtherTicketTypeQuestionOption(question)];
  }

  return question.options;
};
